import { TextCardListCombinedProps } from './types';

const usePresenter = (props: TextCardListCombinedProps): TextCardListCombinedProps => {
  return props;
};

export default usePresenter;
